/**
 * Blank placeholder page with a discrete "[coming soon]" — used for nav
 * destinations that exist in the structure but aren't built yet (Org Chart,
 * Break Room, Internal Outreach). Ken 2026-10-22.
 */
export default function ComingSoon({ title }: { title: string }) {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <div className="text-center">
        <div className="me-brand text-[18px] me-text">{title}</div>
        <div className="mt-2 text-[11px] me-text-mute tracking-[0.08em] uppercase">[ coming soon ]</div>
      </div>
    </div>
  )
}
